import { Icon as PIcon, IconExternalLink } from "@tabler/icons-react";
import { Icon as TIcon } from "@tabler/icons-react";
import { displayCurrencyAmount } from "../utils/display";
import { parseStringToFloat } from "../utils/utilsFunctions/functions";

export interface MinimalCardProps {
  heading: string;
  description: string;
  Icon: PIcon | TIcon;
  currency?: string;
  key: number;
  onClick?: () => void;
  clickAriaLabel?: string;
}

export const MinimalCard = ({
  heading,
  description,
  Icon,
  currency,
  onClick,
  clickAriaLabel,
}: MinimalCardProps) => {
  const formatDescription = () => {
    if (currency) {
      const numericValue = parseStringToFloat(description);
      if (!isNaN(numericValue)) {
        return displayCurrencyAmount(numericValue, currency);
      }
    }
    return description;
  };

  return (
    <div className="flex h-full justify-between gap-3 rounded-xl border border-slate-200 bg-slate-50/60 p-3">
      <div className="min-w-0 flex-1">
        <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
          {heading}
        </p>
        {onClick ? (
          <button
            type="button"
            onClick={onClick}
            aria-label={clickAriaLabel ?? description}
            className="mt-1 inline-flex max-w-full cursor-pointer items-center gap-1 text-left text-lg font-semibold text-blue-600 hover:underline"
          >
            <span className="truncate">{formatDescription()}</span>
            <IconExternalLink
              size={14}
              stroke={1.75}
              className="shrink-0"
              aria-hidden
            />
          </button>
        ) : (
          <p className="mt-1 truncate text-lg font-semibold text-slate-900">
            {formatDescription()}
          </p>
        )}
      </div>
      <div className="h-min shrink-0 self-center rounded-lg border border-slate-200 bg-white p-1.5">
        <Icon className="text-slate-600" size={20} />
      </div>
    </div>
  );
};

export interface MinimalCardListProps {
  cardProps: MinimalCardProps[];
}

export const MinimalCardList = ({ cardProps }: MinimalCardListProps) => {
  return (
    <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {cardProps.map((props) => (
        <MinimalCard key={props.key} {...props} />
      ))}
    </div>
  );
};
